import Cookies from 'js-cookie'
import i18n from '@/i18n/i18n.js'
import { listSystem } from "@/api/system/system";
import { listI18n } from "@/api/system/i18n";

const useAppStore = defineStore(
  'app',
  {
    state: () => ({
      locale: localStorage.getItem('lang') || 'zh',
      i18nLanguageConfig: {}, // 国际化语言配置
      sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false,
        hide: false
      },
      device: 'desktop',
      size: Cookies.get('size') || 'default',
      zoom: 1, // 分辨率放大倍数
      routerActive: true,
      systemList: [], // 子系统列表,
      isDesign: false, // 首页是否设计模式
    }),
    actions: {
      // 设置路由刷新
      SET_ROUTER_ACTIVE(){
        this.routerActive = !this.routerActive;
      },
      SET_ZOOM(zoom){
        this.zoom = zoom;
      },
      SET_LOCALE(locale) { //语言切换
        this.locale = locale
        localStorage.setItem('lang', locale)
        i18n.global.locale.value = locale
      },
      i18nLanguageConfigInit(){
        listI18n({deviceTypeInSet: 'web'}).then(res => {
          if(res?.code === 200){
            let config = {};
            res.data.forEach(item => {
              config[item.i18nTitle] = item.i18nConfigList;
            })
            this.i18nLanguageConfig = config;
          }
        })
      },
      // 获取子系统列表信息
      setSystemList(){ 
        return new Promise((resolve, reject) => {
          listSystem().then(res => {
            if(res?.code === 200){
              this.systemList = res.data;
            }
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
      toggleSideBar(withoutAnimation) {
        if (this.sidebar.hide) {
          return false;
        }
        this.sidebar.opened = !this.sidebar.opened
        this.sidebar.withoutAnimation = withoutAnimation
        if (this.sidebar.opened) {
          Cookies.set('sidebarStatus', 1)
        } else {
          Cookies.set('sidebarStatus', 0)
        }
      },
      closeSideBar(withoutAnimation) {
        Cookies.set('sidebarStatus', 0)
        this.sidebar.opened = false
        this.sidebar.withoutAnimation = withoutAnimation
      },
      toggleDevice(device) {
        this.device = device
      },
      setSize(size) {
        this.size = size;
        Cookies.set('size', size)
      },
      toggleSideBarHide(status) {
        this.sidebar.hide = status
      },
      // 设置
      SET_IS_DESIGN(isDesign){
        this.isDesign = isDesign
      }
    }
  })

export default useAppStore
